import React, { Suspense } from "react";
import { BUIProvider } from "@bookingcom/bui-react";
import travellerTheme from "@bookingcom/bui-react/themes/traveller_ex";
import ErrorReporter from "@bookingcom/react-error-reporter";
import { FlightsErrorReporter } from "../utils/report-error.js";
import AriaLive from "../components/elements/AriaLive/index.js";
import GenericErrorReport from "../components/elements/GenericErrorReport/index.js";
import Trackers from "../components/elements/Trackers/index.js";
import useGlobalContext from "../hooks/useGlobalContext.js";
import useRouteChangeTracking from "../hooks/useRouteChangeTracking.js";
import usePageviewIsNotABounce from "../hooks/usePageviewIsNotABounce.js";
import useWebMigrationCSRStages from "../utils/experiments/feta/flights_feta_web_migration.js";
import useUserAgent from "../hooks/useUserAgent.js";
import { setMarketingTrackingVariables } from "../utils/marketing-url-params.js";
import Layout from "./Layout.js";
import useC360Tracker from "../hooks/useC360Tracker.js";
import { RemoteBottomNav, RemoteHeader } from "../components/remote/index.js";
import useWebShellRouteChange from "../hooks/useWebShellRouteChange.js";
import useEventsTest from "../hooks/useEventsTest.js";
import NoSSR from "./NoSSR/index.js";
import { localizationUtils } from "@flights/web-api-utils-universal";
import SurveyTrackerFlightsUniversal from "../components/remote/SurveyTrackerFlightsUniversal.js";
import { OutletProvider } from "../components/elements/AppShell/Outlet/index.js";
const InternalTools = React.lazy(() => import("../components/elements/InternalTools"));
const App = function ({ stateMap }) {
    const { isMobile } = useUserAgent();
    const { isInternal, marketingTrackingVariables, lang, locale } = useGlobalContext();
    const c360Tracker = useC360Tracker();
    const jsErrorReporter = FlightsErrorReporter.getInstance().errorReporter;
    c360Tracker.initC360();
    useRouteChangeTracking();
    useWebShellRouteChange();
    usePageviewIsNotABounce();
    useWebMigrationCSRStages();
    useEventsTest();
    setMarketingTrackingVariables(marketingTrackingVariables);
    return (React.createElement(OutletProvider, null,
        React.createElement(BUIProvider, { theme: travellerTheme, defaultViewportSize: isMobile ? "small" : "large", defaultRTL: !!(lang && localizationUtils.isRTL(lang)), locale: locale },
            React.createElement(ErrorReporter, { errorDisplayComponent: GenericErrorReport, reporter: jsErrorReporter },
                React.createElement(RemoteHeader, null),
                React.createElement(RemoteBottomNav, null),
                React.createElement(SurveyTrackerFlightsUniversal, null),
                React.createElement(Layout, { stateMap: stateMap }),
                React.createElement(Trackers, null),
                React.createElement(AriaLive, null)),
            React.createElement(NoSSR, null, isInternal && (React.createElement(Suspense, { fallback: null },
                React.createElement(InternalTools, null)))))));
};
export { App as default };
